<template>
    <v-select multiple :options="options" label="id" v-model="innerValue" class="multi-port-selector"
              :placeholder="placeholder" :close-on-select="false" :searchable="true" :clearable="true"
              @search="search" ref="selector">
        <template v-slot:option="option">
            <span class="port-item">{{option.id}}</span>
        </template>
        <template v-slot:no-options>
            <div><span v-if="keyword">未找到“{{keyword}}”</span></div>
        </template>
    </v-select>
</template>

<script>
import AutoWords from "@/services/autoWords";
import _ from "lodash";

export default {
    name: "MultiPortSelector",
    props: ["value", "placeholder", "type"],
    data() {
        return {
            keyword: null,
            innerValue: [],
            options: [],
        }
    },
    methods: {
        syncIn(val) {
            let innerValue = val;
            if (JSON.stringify(this.innerValue.map(x => x)) !== JSON.stringify(innerValue)) {
                this.innerValue = innerValue;
            }
        },
        deselect(option) {
            this.$refs.selector.deselect(option);
        },
        search: _.debounce(function (search, loading) {
            this.doSearch(search, loading);
        }, 300),
        async doSearch(search, loading) {
            let keyword = (search || "").trim();
            if (keyword !== this.keyword) {
                this.keyword = keyword;
                loading(true);
                try {
                    this.options = await AutoWords.words(this.type, this.keyword);
                } finally {
                    loading(false);
                }
            }
        },
    },
    watch: {
        value(val) {
            this.syncIn(val);
        },
        innerValue(val) {
            this.$emit('input', val.map(x => x).filter(x => x));
        }
    },
    created() {
        this.syncIn(this.value);
    }
}
</script>

<style>
.multi-port-selector .vs__dropdown-toggle {
    width: 100%;
    min-height: calc(1.5em + 0.75rem + 2px);
    background-color: white;
}

.multi-port-selector .vs__dropdown-toggle input {
    color: #495057;
}
</style>

<style scoped>
.port-item {
    padding: 0 5px;
}
</style>
